import { FC } from 'react'

export const createCompoundComponent = <TProps, TSubcomponents>(
  Component: FC<TProps>,
  subComponents: TSubcomponents,
) => Object.assign(Component, subComponents)
